import React, { Component } from 'react';

import Tappable from 'react-tappable';

var newBubbles = []

export default class Bubbles extends Component {

    state = ({
      settings: {
        bubbleCount: 100,
        canvasWidth: 0,
        canvasHeight: 0,
        pixelRatio: window.devicePixelRatio || 1
      },
      anchorX: false,
      anchorY: false,
      invertAnchor: false,
      bubbles: [],
    })

  componentDidMount() {
    this.setState({
      settings: {
        canvasWidth: window.innerWidth,
        canvasHeight: window.innerHeight,
        pixelRatio: 1,
        bubbleCount: 100
      },
      anchorX: false,
      anchorY: false,
      invertAnchor: false,
      bubbles: [],
    });

    setTimeout(() => {
      this._setupBubbles();
    }, 1000)
      
    setTimeout(() => {
      this._animateBubbles();
    }, 2000);

    // disable scrolling on ios
    let canvas = this.refs.canvas;
    canvas.addEventListener('touchmove', (e) => {
      e.preventDefault();
    }, false)
    
    
    window.addEventListener('resize', this._resizeCanvas)
    window.addEventListener('mousemove', this._handleMouseMove)
    window.addEventListener('mousedown', this._handleMouseDown)
    window.addEventListener('mouseup', this._handleMouseUp)
  }


  _handlePan = (e) => {
    this.setState({
      anchorX: e.center.x,
      anchorY: e.center.y
    })
  }

  _handleMouseMove = (e) => {
    this.setState({
      anchorX: e.clientX,
      anchorY: e.clientY
    })
  }

  _handleMouseDown = (e) => {
    this.setState({
      invertAnchor: true
    })
  }


  _handleMouseUp = (e) => {
    this.setState({
      invertAnchor: false
    })
  }

  _handleTouchMove = (e) => {
    this.setState({
      anchorX: e.changedTouches[0].clientX,
      anchorY: e.changedTouches[0].clientY
    })
  }

  _handlePress = (e) => {
    this.setState({
      invertAnchor: true
    })
  }
  _handlePressUp = () => {
    this.setState({
      invertAnchor: false
    })
  }
  // Fun little "Easter Egg" I made, lol get it? Pinch your phone on mobile
  _handlePinch = () => {
    window.location.replace('https://media.giphy.com/media/l2R00wfa8fttlpRPG/giphy.gif')
  }

  _resizeCanvas = () => {
    const { settings } = this.state;
    setTimeout(() => {
      let canvas = this.refs.canvas;
      let width = settings.canvasWidth;
      let height = settings.canvasHeight
      let ratio = settings.pixelRatio;
      let ctx = canvas.getContext('2d');
      canvas.width = width * ratio;
      canvas.height = height * ratio;
      ctx.scale(ratio, ratio)
    }, 200)
  }

  _setupBubbles = () => {
    const { settings } = this.state;

    let maxDiam = 30;
    let minDiam = 5;

    let canvas = this.refs.canvas;
    let ctx    = canvas.getContext('2d');

    let width = settings.canvasWidth;
    let height = settings.canvasHeight
    let ratio = settings.pixelRatio;

    canvas.width  = width * ratio;
    canvas.height = height * ratio;

    ctx.scale(ratio, ratio)

    for (let i = 0; i < settings.bubbleCount; i++) {

      let diam = (Math.random() * (maxDiam - minDiam)) + minDiam;
      let x = Math.floor(Math.random() * (width / 1.5) + (width / 6));
      let y = height + (diam / 2) + Math.random() * 100;
      let opacity = Math.random() * 0.3;
      let amplitude = (Math.random() * 400) + 180;

      let bubble = {
        x: x,
        y: y,
        offset: i * 30,
        friction: 0.75 + (Math.random() / 10),
        xMomentum: 0,
        yMomentum: 0,
        radius: diam / 2,
        speed: Math.min((3 + Math.random()) * Math.max((0.25 + Math.random()) / diam, 0.01), 1),
        amplitude: amplitude,
        color: 'rgba(255,255,255,' + Math.min((Math.max(opacity, 0.02)), 0.3) + ')'
      };
        newBubbles.push(bubble);
      }

      this.setState({
        bubbles: newBubbles
      })
  }  


  _animateBubbles = () => {

    const { settings, bubbles } = this.state;

    let ctx = this.refs.canvas.getContext('2d');
    let count = 0;

    let _animate = () => {
      const { anchorX, anchorY, invertAnchor } = this.state;

      let width  = settings.canvasWidth;
      let height = settings.canvasHeight;
      count += 2;

      ctx.clearRect(0, 0, width, height);


      for (let i = 0; i < bubbles.length; i++) {

        let b = bubbles[i];

        if (b.y <= b.radius * -2) {
            b.y = height + b.radius;
        }

        if (b.y >= height + (b.radius * 2)) {
            b.y = -b.radius * 2;
        }

        if (b.x < -b.radius * 2) {
            b.x = width + (b.radius * 2);
        }

        if (b.x > width + (b.radius * 2)) {
            b.x = -b.radius * 2;
        }

        let xSpeed = Math.sin((count + b.offset) / b.amplitude) / 6;
        let yModifier = 0;
        let xModifier = 0;

        if (anchorX !== false) {
          let distance = Math.sqrt(Math.pow(b.y - anchorY, 2) + Math.pow(b.x - anchorX, 2));
          let angle = Math.atan2(b.y - anchorY, b.x - anchorX);
          yModifier = -Math.sin(angle) * Math.max((Math.min(width / 8, 400) - distance) / Math.min(width / 12, 300), 0);
          xModifier = -Math.cos(angle) * Math.max((Math.min(width / 8, 400) - distance) / Math.min(width / 12, 300), 0);
          if (invertAnchor) {
            yModifier = -yModifier;
            xModifier = -xModifier;
          }
        }

        b.yMomentum = (b.yMomentum + b.speed + yModifier) * b.friction;
        b.xMomentum = (b.xMomentum + xSpeed + xModifier) * b.friction;
        b.y = b.y - b.yMomentum;
        b.x = b.x - b.xMomentum;

        ctx.beginPath();

        ctx.fillStyle = b.color;
        ctx.arc(b.x, b.y, b.radius, 0, 2 * Math.PI, false);
        ctx.fill();
      }
    }


    let requestAnimFrame = (() => {
      return window.requestAnimationFrame || 
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        function (callback) {
          window.setTimeout(callback, 1000 / 60);
        };
    })();
    (function animloop() {
      requestAnimFrame(animloop);
      _animate();
    })();

  }


  componentWillUnmount() {
    window.removeEventListener('resize', this._resizeCanvas);
    window.removeEventListener('mousemove', this._handleMouseMove);
    window.removeEventListener('mousedown', this._handleMouseDown);
    window.removeEventListener('mouseup', this._handleMouseUp);
  }

  render() {
    const { settings } = this.state;
    let canvasStyles = {
      width: settings.canvasWidth + 'px',
      height: settings.canvasHeight + 'px'
    }
    return (
      <div>
        <Tappable onPinchStart={this._handlePinch} onTouchStart={this._handlePress} pressDelay={500} onTouchMove={this._handleTouchMove} onTouchEnd={this._handlePressUp}>
          <canvas className="canvas" ref="canvas" style={canvasStyles}>
          </canvas>
        </Tappable>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Home/components/Bubbles/index.js